import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import { Backdrop, CircularProgress } from "@mui/material";

const OrthoultraSound = ({ ismodal, setIsmodal, data }) => {
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("error");
  const practiseid = window.getPracticeId();
  const formattedDOB = dayjs(data?.dob).format("DD-MM-YYYY");
  const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");
  const age = calculateAge(data?.dob);
  const [providerList, setProviderList] = useState([]);
  const [formData, setFormData] = useState({
    provider: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    history: "",
    impression: "",
    signature: "",
    preliminary: "",
    location: "",
    measurements: [],
  });
 const[isLoading,setIsLoading]=useState(false)
  const [showMeasurementFields, setShowMeasurementFields] = useState(false);
  const [measurement1, setMeasurement1] = useState("");
  const [measurement2, setMeasurement2] = useState("");
  const [unit, setUnit] = useState("cm");

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleAddMeasurement = () => {
    setShowMeasurementFields(true);
  };const resetForm = () => {
  setFormData({
    provider: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    history: "",
    impression: "",
    signature: "",
    preliminary: "",
    location: "",
    measurements: [],
  });

  setMeasurement1("");
  setMeasurement2("");
  setUnit("cm");

  setShowMeasurementFields(false);
  setIsLoading(false);
};


  useEffect(() => {
    if (ismodal) getProviders();
  }, [ismodal]);
useEffect(() => {
  if (!formData.provider && providerList.length > 0) {
    const providerNames = providerList.map(x => x.providername);

    if (data?.linked_provider && providerNames.includes(data.linked_provider)) {
      handleChange("provider", data.linked_provider);   // ✅ fixed
    } else {
      handleChange("provider", providerList[0].providername);  // ✅ fixed
    }
  }
}, [providerList, data, formData.provider]);

  const getProviders = async () => {
    try {
      const response = await api.get(`/v1/${practiseid}/providers`);
      if (response.status === 200 && Array.isArray(response.data)) {
        setProviderList(response.data);
      }
    } catch (error) {
      setToastMessage("Failed to load providers");
      setToastSeverity("error");
      setOpenToast(true);
    }
  };

  const handleSaveMeasurement = () => {
    if (measurement1 && measurement2) {
      const newMeasurement = {
        width: measurement1,
        height: measurement2,
        unit,
      };
      const updatedMeasurements = [...formData.measurements, newMeasurement];
      setFormData((prev) => ({
        ...prev,
        measurements: updatedMeasurements,
     
      }));
      setMeasurement1("");
      setMeasurement2("");
      setShowMeasurementFields(false);
    }
  };

  const handleRemoveMeasurement = (index) => {
    const updated = [...formData.measurements];
    updated.splice(index, 1);
    setFormData((prev) => ({
      ...prev,
      measurements: updated,
    
    }));
  };

  const validateForm = () => {
    const errors = [];
    if (!formData.provider) errors.push("Provider is required.");
    if (!formData.examDate) errors.push("Exam Date is required.");
    if (!formData.history.trim()) errors.push("Patient History is required.");
    if (!formData.impression.trim()) errors.push("Impression is required.");
    if (!formData.signature.trim()) errors.push("Signature is required.");
    return errors;
  };

  const handleSave = async() => {
    const errors = validateForm();
    if (errors.length > 0) {
      setToastMessage(errors[0]);
      setToastSeverity("error");
      setOpenToast(true);
    } else {
    const selectedProvider = providerList.find(
        (p) => p.providername === formData.provider
      );

      const patientDetails = {
        patientid: data.patientid,
        appointmentid: data.appointmentid,
        firstname: data.firstname,
        lastname: data.lastname,
        providername: formData.provider,
        providerid: selectedProvider?.providerid,
        pat_name: `${data?.firstname} ${data?.lastname}`,
          pat_dob: data?.dob,
        dob: formattedDOB,
        age,
        gender: data.gender === "M" ? "Male" : "Female",
      };
      let payload={...patientDetails,...formData}
try {
    setIsLoading(true)

     const user=await api.get('/auth/me')
          const [year, month, day] = formData.examDate.split("-");
          const formattedDate = `${month}/${day}/${year}`;
      
      const response = await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/insert-db`, {
        "Worksheet_Type": "ORTHO_ULTRASOUND",
        "createdby": user?.username || '',
        "appurl": window.location.origin,
          // "appurl": "",
        "Exam_Date": formattedDate,
        "data":payload
      });
      
      if(response.status==200){
        const pdf=await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/generate-pdf`,{
        "filename": response?.data?.filename,      
        "worksheet_type":"ORTHO_ULTRASOUND",
         "appurl": window.location.origin,
        "exam_date": formattedDate
        })
        setToastMessage("Form Submitted Successfully");
          setToastSeverity("success");
          setOpenToast(true);
          resetForm()
       setTimeout(() => {
    
        setIsmodal(false);
      }, 1000);
      
      }else{
        setToastMessage(response.message);
          setToastSeverity("info");
          setOpenToast(true);
      }
} catch (error) {
  console.log(error)
}finally{
setIsLoading(false)
}
    }
  };

  if (!ismodal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto min-h-screen px-2 py-6">
      <div className="w-full max-w-4xl text-start bg-white rounded-lg p-6 shadow-xl relative">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">ORTHO ULTRASOUND</h2>
          <button
            onClick={() => setIsmodal(false)}
            className="text-xl font-bold text-gray-500 hover:text-black"
          >
            ×
          </button>
        </div>
        <hr className="mb-4 border-gray-300" />

        {/* Patient Info */}
        <div className="flex items-center space-x-4 mb-4">
          <img
            src={`/cloud-assets/chim/public/assets/images/profilepictures/${data.patientid}.png`}
            alt="User"
            className="w-16 h-full max-h-28 rounded-md object-cover"
          />
          <div className="space-y-1">
            <div className="text-white bg-violet-500 rounded-lg px-1.5 py-0.5 text-xs font-medium inline-block">
   #{data?.patientid}
            </div>
            <div className="text-base font-semibold">
              {data?.firstname + " " + data?.lastname}
            </div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Date of Birth:</span>{" "}
              {formattedDOB}
            </div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Age:</span> {age} |{" "}
              <span className="font-semibold">Gender:</span>{" "}
              {data?.gender === "M" ? "Male" : "Female"}
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Providers</label>
            <select
              className="w-full border rounded px-2 py-1"
              value={formData.provider}
              onChange={(e) => handleChange("provider", e.target.value)}
            >
              <option value="">Select Provider</option>
              {providerList.map((provider) => (
                <option
                  key={provider.providerid}
                  value={provider.providername}
                >
                  {provider.providername}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Exam Date</label>
            <input
              type="date"
              className="w-full border rounded px-2 py-1"
              value={formData.examDate}
              onChange={(e) => handleChange("examDate", e.target.value)}
            />
          </div>
        </div>

        <div className="mt-4 flex items-center space-x-6">
          <label className="text-sm font-medium">Preliminary</label>
          <div className="flex items-center space-x-4">
            <label className="flex items-center space-x-1">
              <input
                type="radio"
                name="preliminary"
                value="yes"
                checked={formData.preliminary === "yes"}
                onChange={(e) => handleChange("preliminary", e.target.value)}
              />
              <span className="text-sm">Yes</span>
            </label>
            <label className="flex items-center space-x-1">
              <input
                type="radio"
                name="preliminary"
                value="no"
                checked={formData.preliminary === "no"}
                onChange={(e) => handleChange("preliminary", e.target.value)}
              />
              <span className="text-sm">No</span>
            </label>
          </div>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Patient History</label>
          <textarea
            className="w-full border rounded px-2 py-1 mt-1"
            rows={3}
            value={formData.history}
            onChange={(e) => handleChange("history", e.target.value)}
          />
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Location</label>
          <input
            type="text"
            className="w-full border rounded px-2 py-1 mt-1"
            placeholder="Location"
            value={formData.location}
            onChange={(e) => handleChange("location", e.target.value)}
          />
          <button
            className="mt-2 bg-yellow-500 text-white px-3 py-1 rounded"
            onClick={handleAddMeasurement}
          >
            Add +
          </button>
        </div>

        {showMeasurementFields && (
          <div className="mt-4 flex items-center space-x-4">
            <input
              type="text"
              className="w-1/4 border rounded px-2 py-1"
              placeholder="Enter value"
              value={measurement1}
              onChange={(e) => setMeasurement1(e.target.value)}
            />
            <input
              type="text"
              className="w-1/4 border rounded px-2 py-1"
              placeholder="Enter value"
              value={measurement2}
              onChange={(e) => setMeasurement2(e.target.value)}
            />
            <select
              className="w-1/6 border rounded px-2 py-1"
              value={unit}
              onChange={(e) => setUnit(e.target.value)}
            >
              <option value="cm">cm</option>
              <option value="mm">mm</option>
            </select>
            <button
              className="bg-green-500 text-white px-3 py-1 rounded"
              onClick={handleSaveMeasurement}
            >
              ✔
            </button>
          </div>
        )}

        {formData.measurements.length > 0 && (
  <div className="mt-4 grid gap-2">
    {formData.measurements.map((m, i) => (
      <div
        key={i}
        className="flex flex-wrap justify-between items-center border border-gray-300 rounded-lg p-3 bg-gray-50"
      >
        <div className="flex  sm:space-x-6 space-y-1 sm:space-y-0">
          <div className="text-sm text-gray-700">
            <span className="font-medium">Width:</span> {m.width}
          </div>
          <div className="text-sm text-gray-700">
            <span className="font-medium">Height:</span> {m.height}
          </div>
          <div className="text-sm text-gray-700">
            <span className="font-medium">Unit:</span> {m.unit}
          </div>
        </div>

        <button
          className="text-red-500 text-lg font-semibold ml-4 hover:text-red-700"
          onClick={() => handleRemoveMeasurement(i)}
        >
          ×
        </button>
      </div>
    ))}
  </div>
)}


        <div className="mt-4">
          <label className="block text-sm font-medium">
            Sonographer's Impression
          </label>
          <textarea
            className="w-full border rounded px-2 py-1 mt-1"
            rows={3}
            value={formData.impression}
            onChange={(e) => handleChange("impression", e.target.value)}
          />
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Signature</label>
          <input
            className="w-full border rounded px-2 py-1 mt-1"
            placeholder="Signature"
            value={formData.signature}
            onChange={(e) => handleChange("signature", e.target.value)}
          />
        </div>

        <div className="flex justify-end mt-6">
          <button
            onClick={handleSave}
            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
          >
            Save
          </button>
        </div>
      </div>
<Backdrop
  sx={{
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
  }}
  open={isLoading}
>
  <CircularProgress color="inherit" />
</Backdrop>
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={() => setOpenToast(false)}
      />
    </div>
  );
};

export default OrthoultraSound;
